import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { CircleLight } from './CircleLight';
import { AmbientLight } from './AmbientLight';
import { useLanguage } from '../context/LanguageContext';
const ROMAN = ['I', 'II', 'III'];
const IMGS = [IMAGES.openBox, IMAGES.flavorPistachio, IMAGES.trio];
export function Product() {
  const {
    t
  } = useLanguage();
  return <section id="product" className="relative overflow-hidden py-32 lg:py-48 bg-texture-dark text-cream" data-id="element-309" data-mp="1afmwollwif1x">
      <AmbientLight variant="top" seam data-id="element-310" data-mp="1f7daj1k1rky3" />
      <div className="relative z-10 max-w-[1300px] mx-auto px-8 lg:px-14" data-id="element-311" data-mp="1f8g45h8r81hp">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 1
      }} className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end" data-id="element-312" data-mp="11h1ggx3wjc4b">
          <div className="lg:col-span-6" data-id="element-313" data-mp="1ifbia6kbc657">
            <div className="flex items-center gap-3 text-caramel text-[10px] tracking-[0.4em] uppercase mb-10" data-id="element-314" data-mp="1denlf49ekv32">
              <span className="w-10 h-px bg-caramel/40" data-id="element-315" data-mp="1rcu7zo8wj8nf" />
              {t.product.eyebrow}
            </div>
            <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl xl:text-8xl text-cream leading-[0.95] tracking-[-0.02em] font-light" data-id="element-316" data-mp="1mg3un8oher5p">
              {t.product.title1}
              <br data-id="element-317" data-mp="uo61np6jt9tu" />
              <span className="italic font-extralight" data-id="element-318" data-mp="uoo10uoic45z">{t.product.title2}</span>
            </h2>
          </div>
          <div className="lg:col-span-6" data-id="element-319" data-mp="18glzmbklehnw">
            <p className="text-cream/60 leading-[1.85] text-[15px] max-w-lg" data-id="element-320" data-mp="13ob2fgh8l9z1">
              {t.product.intro}
            </p>
          </div>
        </motion.div>

        <div className="mt-28 lg:mt-36 grid md:grid-cols-3 gap-y-20 md:gap-y-0 md:gap-x-12 lg:gap-x-16" data-id="element-321" data-mp="fx5iap49jvix">
          {t.product.features.map((f, i) => <motion.article key={f.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 1,
          delay: i * 0.12,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative group text-center" data-id="element-322" data-mp="2b2epcapnbbez" data-mpi={i}>
              <span aria-hidden className="absolute left-1/2 -translate-x-1/2 -top-10 font-serif italic font-extralight text-cream/[0.06] select-none pointer-events-none leading-none" style={{
            fontSize: 'clamp(140px, 18vw, 220px)'
          }} data-id="element-323" data-mp="1x3yk6o7flsyy">
                {ROMAN[i]}
              </span>

              <div className="relative inline-block" data-id="element-324" data-mp="3hg5n7r7tilex">
                <div className="absolute -inset-2 rounded-full ring-1 ring-cream/10" aria-hidden data-id="element-325" data-mp="15v569wpvf87o" />
                <CircleLight speed="slow" className="!-inset-1" data-id="element-326" data-mp="11v4qo8r1cqz1" />
                <div className="relative w-40 h-40 lg:w-48 lg:h-48 rounded-full overflow-hidden ring-1 ring-cream/15 transition-transform duration-[1400ms] group-hover:scale-[1.04]" style={{
              boxShadow: '0 24px 50px -20px rgba(0,0,0,0.6), 0 0 0 1px rgba(247,240,232,0.05)'
            }} data-id="element-327" data-mp="x1a0cmgxddqz">
                  <img src={IMGS[i]} alt={`TARTA Basque cheesecake — ${f.title}`} className="absolute inset-0 w-full h-full object-cover" data-id="element-328" data-mp="e4h3yhcgnwsf" />
                  <div className="absolute inset-0 pointer-events-none" style={{
                background: 'radial-gradient(circle at 35% 30%, rgba(247,240,232,0.15), transparent 55%)'
              }} data-id="element-329" data-mp="28g5jolqio3dv" />
                </div>
              </div>

              <div className="relative mt-10 flex items-center justify-center gap-3 text-caramel" data-id="element-330" data-mp="r6s575m1ut4q">
                <span className="w-1 h-1 rotate-45 bg-caramel/70" aria-hidden data-id="element-331" data-mp="w5uyxtwkxcxe" />
                <span className="font-serif italic text-[13px] tracking-[0.05em]" data-id="element-332" data-mp="w7zb0z4mti8r">
                  {f.eyebrow}
                </span>
                <span className="w-1 h-1 rotate-45 bg-caramel/70" aria-hidden data-id="element-333" data-mp="m88gixg2n38o" />
              </div>

              <h3 className="relative mt-5 font-serif text-3xl lg:text-[34px] text-cream font-light tracking-[-0.01em] leading-[1.05]" data-id="element-334" data-mp="8gtwqoecay0k">
                {f.title}
              </h3>

              <p className="relative mt-6 text-cream/55 leading-[1.85] text-[14px] max-w-[280px] mx-auto" data-id="element-335" data-mp="3unidjr53ti9l">
                {f.copy}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}